import {
  Control,
  FieldPath,
  FieldValues,
  RegisterOptions,
} from "react-hook-form";

import { SelectInput } from "@components/Forms/ControlledInputs";

const COUNTRY_OPTIONS = [
  { id: "USA", label: "United States" },
  { id: "CAN", label: "Canada" },
  { id: "HK", label: "Hong Kong" },
  { id: "UK", label: "United Kingdom" },
];

type CountrySelectorProps<T extends FieldValues> = {
  control: Control<T>;
  name: FieldPath<T>;
  disabled?: boolean;
  rules?: RegisterOptions<T>;
  onChange?: (value: string) => void;
};

const CountrySelector = <T extends FieldValues>({
  control,
  name,
  disabled,
  rules,
  onChange,
}: CountrySelectorProps<T>) => (
  <SelectInput
    label="Country"
    name={name}
    control={control}
    rules={rules}
    options={COUNTRY_OPTIONS}
    disabled={disabled}
    fullWidth
    onChange={(event) => onChange?.(event.target.value as string)}
  />
);

export default CountrySelector;
